export interface NavItem {
  path: string;
  icon: string;
  label: string;
}

// 기본 탭 아이템 - 단일 소스
export const defaultNavItems: NavItem[] = [
  { path: '/mobile/home', icon: 'mdi:home', label: '인사평가 홈' },
  {
    path: '/mobile/eval/evaluation-results',
    icon: 'mdi:comment-text-outline',
    label: '내 평가결과',
  },
];
